import { Typography } from "@mui/material";
import { marked } from "marked";
import React, { Fragment, useState } from "react";
import AnomalyIco from "../../../../assets/icons/AnomalyIco";
import ExclamatoryIco from "../../../../assets/icons/ExclamatoryIco";
import ResultStar from "../../../../assets/icons/ResultStarIco";
import SomeGapIco from "../../../../assets/icons/SomeGapIco";
import { ReactComponent as ChatBotIcon } from "../../../../assets/images/ChatBotIcon.svg";
import CommonButton from "../../../../component/Button";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import {
  CommonGrid2,
  StyledFlexRowView,
} from "../../../common-components/StyledComponents";
import { CommonTippy, CustomizeSpan } from "../../../jobs/style";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";

export default function Score({
  jobData,
  isLoading,
  fetchJobsList,
  toolTipOpen = false,
  job_id,
  fixLoader = false,
  disabled,
  data,
  searchLoading,
  handleReviewInfo,
  mandatoryDisabled,
  anomalyDisabled,
  filterInferredSkill,
  filterFieldLevelData,
  hideCondition = true,
  condition_based = false,
  scoreEnable = true,
}) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Fragment>
      {data !== undefined ? (
        <Fragment>
          {searchLoading ? (
            <Fragment>
              {Array.from({ length: 3 }).map((_, index) => (
                <HandleSkeletion height={80} key={index} />
              ))}
            </Fragment>
          ) : data !== "" ? (
            <CommonGrid2
              borderRadius={"10px"}
              padding={"12px"}
              background="#EBF8FF"
              gap={"1rem"}
              display={"flex"}
            >
              <CustomDiv>
                <ResultStar />
              </CustomDiv>

              <CommonGrid2
                display={"flex"}
                gap={"0px"}
                flexDirection={"column"}
              >
                <Fragment>
                  <div
                    className={`markdown-content data-margin-check ${
                      expanded ? "expanded" : "collapsed"
                    }`}
                    dangerouslySetInnerHTML={{
                      __html: marked(data || ""),
                    }}
                  />
                  {data?.length > 100 && (
                    <span
                      onClick={() => setExpanded(!expanded)}
                      style={{
                        color: "#7F56D9",
                        cursor: "pointer",
                        fontWeight: 600,
                        display: "inline-block",
                        marginTop: 6,
                      }}
                    >
                      {expanded ? "See Less" : "See More"}
                    </span>
                  )}
                </Fragment>
              </CommonGrid2>
            </CommonGrid2>
          ) : (
            ""
          )}
        </Fragment>
      ) : (
        <CustomDiv>
          <CustomDiv
            border={"1px solid #EAECF0"}
            borderRadius={"10px"}
            padding={
              mandatoryDisabled ||
              anomalyDisabled ||
              filterInferredSkill ||
              filterFieldLevelData
                ? "1rem 1rem 1rem 5px"
                : "1px 5px"
            }
            margin="1rem 0px 0px"
          >
            <CommonGrid2
              display={"flex"}
              gap={"2px"}
              alignItems={"center"}
              width={"100%"}
            >
              {isLoading ? (
                <HandleSkeletion
                  width="50px"
                  height="50px"
                  marginRight={"1rem"}
                  transform="scale(1)"
                  borderRadius="50px"
                />
              ) : (
                <CustomDiv display="flex">
                  <ChatBotIcon style={{ width: "70px", height: "70px" }} />
                </CustomDiv>
              )}
              {
                <CommonGrid2
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"2px"}
                  width={"100%"}
                >
                  {scoreEnable && (
                    <Fragment>
                      {isLoading ? (
                        <HandleSkeletion
                          width="300px"
                          height="30px"
                          transform="scale(1)"
                        />
                      ) : (
                        <Typography variant="body3" fontWeight={600}>
                          {"Here is the AI Analysis of the Job Description !"}
                        </Typography>
                      )}
                      {isLoading ? (
                        <HandleSkeletion height={50} width={"100px"} />
                      ) : (
                        <CommonGrid2
                          display={"flex"}
                          gap={"10px"}
                          alignItems={"center"}
                        >
                          <Typography variant="div" fontWeight={500}>
                            {"Analysis Score"}
                          </Typography>

                          <Typography
                            variant="subtitle1"
                            border={"1px solid #AAEFC6"}
                            backgroundColor="#ECFDF3"
                            color={"#067647"}
                            padding={"0px 10px"}
                            borderRadius={"50px"}
                            fontWeight={600}
                          >
                            {jobData?.score_label} - {`${jobData?.score}%`}
                          </Typography>
                        </CommonGrid2>
                      )}
                    </Fragment>
                  )}
                  {isLoading ? (
                    <HandleSkeletion
                      width="100%"
                      height="30px"
                      transform="scale(1)"
                    />
                  ) : (
                    <Fragment>
                      {!condition_based &&
                        (mandatoryDisabled ||
                          anomalyDisabled ||
                          filterInferredSkill ||
                          filterFieldLevelData) && (
                          <CommonGrid2
                            borderRadius={"10px"}
                            padding={"1rem"}
                            background={"#F7F8F9"}
                            marginTop={scoreEnable && "10px"}
                          >
                            <CommonGrid2
                              display={"flex"}
                              justifyContent={"space-between"}
                              flexWrap={"wrap"}
                              gap={"1rem"}
                              alignItems={"center"}
                            >
                              <CommonGrid2 display={"flex"} gap={"1rem"}>
                                <CommonGrid2 display={"flex"}>
                                  <SomeGapIco
                                    color={
                                      "#FF4F6F"
                                      // !anomalyDisabled && !mandatoryDisabled
                                      //   ? "green"
                                      //   : "#FF4F6F"
                                    }
                                  />
                                </CommonGrid2>
                                <CommonGrid2
                                  display={"flex"}
                                  flexDirection={"column"}
                                >
                                  <Typography variant="h5">
                                    Improve Score by fixing anomalies and adding
                                    the missing information.
                                  </Typography>

                                  <CommonGrid2
                                    marginTop={"1rem"}
                                    display={"flex"}
                                    flexWrap={"wrap"}
                                    // gap={"2rem"}
                                    columnGap={"2rem"}
                                    rowGap={"1rem"}
                                  >
                                    {/* {mandatoryDisabled && ( */}
                                    <CommonGrid2
                                      display={"flex"}
                                      gap={"10px"}
                                      alignItems={"center"}
                                      flexWrap={"wrap"}
                                    >
                                      <AnomalyIco
                                        color={
                                          mandatoryDisabled
                                            ? "#A9B4BE"
                                            : "green"
                                        }
                                      />
                                      <Typography variant="body4">
                                        Mandatory Fields
                                      </Typography>
                                    </CommonGrid2>
                                    {/* )} */}
                                    {scoreEnable && (
                                      <CommonGrid2
                                        display={"flex"}
                                        gap={"10px"}
                                        alignItems={"center"}
                                      >
                                        <AnomalyIco
                                          color={
                                            "#A9B4BE"
                                            // anomalyDisabled ? "#A9B4BE" : "green"
                                          }
                                        />
                                        <Typography variant="body4">
                                          Review Anomalies
                                        </Typography>
                                        {jobData?.insights?.anomalies_count
                                          ?.ignored !== 0 && (
                                          <CommonGrid2
                                            display={"flex"}
                                            alignItems={"center"}
                                            border={"1px solid #EAECF0"}
                                            background="#fff"
                                            borderRadius={"50px"}
                                            padding={"3px 12px 3px 3px"}
                                            gap={"5px"}
                                          >
                                            <Typography
                                              border={"1px solid #AAEFC6"}
                                              backgroundColor="#ECFDF3"
                                              borderRadius={"50px"}
                                              padding={"0px 8px"}
                                              fontWeight={700}
                                              color="#067647"
                                            >
                                              {
                                                jobData?.insights
                                                  ?.anomalies_count?.ignored
                                              }
                                              /
                                              {
                                                jobData?.insights
                                                  ?.anomalies_count?.total
                                              }
                                            </Typography>

                                            <Typography>Ignored</Typography>
                                          </CommonGrid2>
                                        )}
                                      </CommonGrid2>
                                    )}
                                  </CommonGrid2>
                                </CommonGrid2>
                              </CommonGrid2>

                              <CommonButton
                                value={"Review Info."}
                                variant="text"
                                gap="0px"
                                padding={"5px 15px"}
                                border={"#D0D5DD"}
                                background={"#fff"}
                                fontWeight={700}
                                onClick={handleReviewInfo}
                              />
                            </CommonGrid2>
                          </CommonGrid2>
                        )}
                    </Fragment>
                  )}
                </CommonGrid2>
              }
            </CommonGrid2>
          </CustomDiv>
          <CommonGrid2
            gap={isLoading ? "0px" : "1rem"}
            display={"flex"}
            flexDirection={"column"}
          >
            {isLoading ? (
              <>
                {Array.from({ length: 3 }).map((_, index) => (
                  <HandleSkeletion height={80} key={index} />
                ))}
              </>
            ) : (
              <Fragment>
                {Array.isArray(jobData?.insights?.jd_recruiter_cheat_sheet) &&
                  jobData.insights.jd_recruiter_cheat_sheet.length > 0 && (
                    <CommonGrid2
                      borderRadius={"10px"}
                      padding={"12px"}
                      background="#EBF8FF"
                      gap={"1rem"}
                      display={"flex"}
                      marginTop={"0.8rem"}
                    >
                      <CustomDiv>
                        <ResultStar />
                      </CustomDiv>

                      <CommonGrid2
                        display={"flex"}
                        gap={"0px"}
                        flexDirection={"column"}
                      >
                        <Fragment>
                          <Typography fontSize={"15px"} color="#00144A">
                            <CustomizeSpan fontWeight={700} color="#00144A">
                              {" "}
                              Search Strategy:
                            </CustomizeSpan>{" "}
                            I have analyzed the job description and other
                            relevant information and here is what you need to
                            know,
                          </Typography>

                          <ul>
                            {jobData?.insights?.jd_recruiter_cheat_sheet.map(
                              (listItem) => (
                                <li
                                  style={{
                                    fontSize: "15px",
                                    color: "#00144A",
                                    fontFamily: "Inter",
                                  }}
                                >
                                  {listItem}
                                </li>
                              )
                            )}
                          </ul>
                        </Fragment>
                      </CommonGrid2>
                    </CommonGrid2>
                  )}

                {jobData?.insights?.jd_recruiter_cheat_sheet &&
                  (jobData?.insights?.jd_recruiter_cheat_sheet.cheat_sheet ||
                    jobData?.insights?.jd_recruiter_cheat_sheet
                      .recommendations) && (
                    <Fragment>
                      <CommonGrid2
                        borderRadius={"10px"}
                        padding={"12px"}
                        background="#EBF8FF"
                        gap={"1rem"}
                        display={"flex"}
                        marginTop={"0.8rem"}
                      >
                        <CustomDiv>
                          <ResultStar />
                        </CustomDiv>

                        <CommonGrid2
                          display={"flex"}
                          gap={"0px"}
                          flexDirection={"column"}
                        >
                          {jobData?.insights?.jd_recruiter_cheat_sheet
                            .cheat_sheet && (
                            <Fragment>
                              <Typography fontSize={"15px"} color="#00144A">
                                <CustomizeSpan fontWeight={700} color="#00144A">
                                  {" "}
                                  Search Strategy:
                                </CustomizeSpan>{" "}
                                I have analyzed the job description and other
                                relevant information and here is what you need
                                to know,
                              </Typography>

                              <ul>
                                {jobData?.insights?.jd_recruiter_cheat_sheet.cheat_sheet.map(
                                  (listItem) => (
                                    <li
                                      style={{
                                        fontSize: "15px",
                                        color: "#00144A",
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      {listItem}
                                    </li>
                                  )
                                )}
                              </ul>
                            </Fragment>
                          )}
                          {(mandatoryDisabled ||
                            anomalyDisabled ||
                            filterInferredSkill ||
                            filterFieldLevelData) &&
                            jobData?.insights?.jd_recruiter_cheat_sheet
                              .recommendations &&
                            jobData?.insights?.jd_recruiter_cheat_sheet
                              .recommendations?.length !== 0 && (
                              <Fragment>
                                <Typography fontSize={"15px"} color="#00144A">
                                  <CustomizeSpan
                                    fontWeight={700}
                                    color="#00144A"
                                  >
                                    {" "}
                                    Recommendation and Next Steps:
                                  </CustomizeSpan>{" "}
                                  Based on my analysis, here is my
                                  recommendation,
                                </Typography>
                                <ul>
                                  {jobData?.insights?.jd_recruiter_cheat_sheet.recommendations.map(
                                    (listItem) => (
                                      <li
                                        style={{
                                          fontSize: "15px",
                                          color: "#00144A",
                                          fontFamily: "Inter",
                                        }}
                                      >
                                        {listItem}
                                      </li>
                                    )
                                  )}
                                </ul>
                                <Typography
                                  fontSize={"15px"}
                                  color="#00144A"
                                  fontWeight={700}
                                >
                                  If I can be of any additional help, just ask!
                                </Typography>
                              </Fragment>
                            )}
                        </CommonGrid2>
                      </CommonGrid2>
                    </Fragment>
                  )}

                {/* )} */}
                {hideCondition &&
                  jobData?.insights?.insights?.map((item, index) => {
                    if (item.fix) return null;

                    return (
                      <CommonGrid2
                        key={index}
                        container
                        borderRadius={"10px"}
                        padding={"10px"}
                        background="#F7F8F9"
                        gap={"10px"}
                        marginTop={"0.8rem"}
                      >
                        <StyledSpaceBetweenBox
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <StyledFlexRowView>
                            {/* <div
                        style={{
                          background: item.fix
                            ? "unset"
                            : hexToRgba("#DCFAE6", 0.6),
                          borderRadius: "50%",
                          padding: "5px 10px",
                          ...(item.fix && {
                            display: "flex",
                            alignItems: "center",
                          }),
                        }}
                      >
                        <ExclamatoryIco />
                        {item.fix ? <FixIco /> : <TickIcon color={"green"} />}
                      </div> */}
                            <CommonGrid2 display={"flex"} minWidth={"auto"}>
                              <ExclamatoryIco />
                            </CommonGrid2>

                            <Typography variant="body4" color="#00144A">
                              {item.content}
                            </Typography>
                          </StyledFlexRowView>

                          {item.fix && (
                            <CommonTippy
                              content={"Processing... please wait some minutes"}
                              visible={fixLoader}
                              placement="top"
                              disabled={toolTipOpen}
                              color="#7F56D9"
                              fontWeight={600}
                              fontSize={"12px"}
                              textAlign="center"
                            >
                              <CommonTippy
                                content="If you fix this, any changes that have been made may be lost."
                                placement="top"
                                color="#7F56D9"
                                disabled={toolTipOpen || fixLoader}
                                fontWeight={600}
                                fontSize={"12px"}
                                textAlign="center"
                              >
                                <div>
                                  <CommonButton
                                    variant="outlined"
                                    color="#344054"
                                    border="#D0D5DD"
                                    fontWeight="600"
                                    onClick={() => fetchJobsList(job_id)}
                                    disabled={fixLoader || disabled}
                                    loading={fixLoader}
                                    value={item?.value ? item?.value : "Fix"}
                                    style={{
                                      marginLeft: "auto",
                                    }}
                                  />
                                </div>
                              </CommonTippy>
                            </CommonTippy>
                          )}
                        </StyledSpaceBetweenBox>
                      </CommonGrid2>
                    );
                  })}
              </Fragment>
            )}
          </CommonGrid2>
        </CustomDiv>
      )}
    </Fragment>
  );
}
